import { render, staticRenderFns } from "./TestimSlider.vue?vue&type=template&id=68e63ef0&"
import script from "./TestimSlider.vue?vue&type=script&lang=js&"
export * from "./TestimSlider.vue?vue&type=script&lang=js&"
import style0 from "./TestimSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports